export const DEFAULT_PROFILE_IMG = "/assets/images/avatar.png";
export const languages = [
    { id: "0", name: "English" },
    { id: "1", name: "French" }
];
